import React from "react";
import Logo from "@/components/ui/Logo";

/**
 * Layout sencillo para páginas legales (Términos, Privacidad, etc.)
 */
const LegalLayout = ({ title, children }) => {
    return (
        <div className="min-h-screen bg-[#0a0f1a] text-slate-300 font-sans selection:bg-primary/30">
            {/* Header */}
            <header className="border-bottom border-white/5 bg-[#0a0f1a]/80 backdrop-blur-md sticky top-0 z-50">
                <div className="max-w-4xl mx-auto px-6 h-20 flex items-center justify-between">
                    <a href="/" className="hover:opacity-80 transition-opacity">
                        <Logo size={20} />
                    </a>
                    <a href="/" className="text-xs font-black uppercase tracking-widest text-white/40 hover:text-white transition-colors">
                        Volver al inicio
                    </a>
                </div>
            </header>

            {/* Content */}
            <main className="max-w-4xl mx-auto px-6 py-20">
                <div className="glass-effect p-8 md:p-12 rounded-[2.5rem] border border-white/10 animate-fade-in shadow-2xl">
                    <h1 className="text-4xl md:text-5xl font-black text-white mb-10 tracking-tight leading-tight">
                        {title}
                    </h1>
                    <div className="prose prose-invert prose-slate max-w-none 
                        prose-headings:text-white prose-headings:font-black prose-headings:mt-12
                        prose-p:leading-relaxed prose-p:text-slate-400 prose-p:mb-6
                        prose-li:text-slate-400 prose-li:mb-2
                        prose-strong:text-white prose-strong:font-bold
                    ">
                        {children}
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer className="max-w-4xl mx-auto px-6 py-20 text-center border-t border-white/5">
                <p className="text-[10px] font-black uppercase tracking-[0.2em] text-white/20">
                    © {new Date().getFullYear()} Conexo POS — Plataforma Tecnológica para Restaurantes
                </p>
            </footer>
        </div>
    );
};

export default LegalLayout;
